<div class="title p-2">
    <div class="row">
        <div class="col d-flex justify-content-between align-items-center">
            <h1 class="mx-2 mt-3">
                <span>Info cerere
                    {{ cerere?.indoc_number ? cerere?.indoc_number : "N/A" }} /
                    {{ cerere?.created_date }}
                </span>
                <span class="text-secondary m-2">#{{ cerere?.id_cerere }}</span>
                <button type="button" class="btn btn-small btn-primary" (click)="getCerereInfo()">
                    <i class="fa-solid fa-arrows-rotate"></i>
                    <span class="ms-2"> Reîncarcă informații</span>
                </button>
            </h1>
        </div>
        <div class="col d-flex justify-content-end">
            <button type="button" class="action-btn" (click)="closeDialog()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
</div>
<div class="row p-3 responsive-content">
    <div class="col-8">
        <mat-card>
            <div class="row">
                <div class="col-md" *ngIf="cerere">
                    <app-subsemnat [cerere]="cerere"></app-subsemnat>
                </div>
                <div class="col-md" *ngIf="cerere && !isCorespondenta">
                    <app-informatii-aditionale [cerere]="cerere"></app-informatii-aditionale>
                </div>
            </div>

            <app-documente-cerere *ngIf="cerere && !isCorespondenta" [cerere]="cerere"
                (isLoading)="onIsLoadingChange($event)"></app-documente-cerere>

            <app-mesagerie *ngIf="cerere" [cerere]="cerere" (cerereChanged)="onCerereChanged($event)"></app-mesagerie>

            <app-istoric-cerere *ngIf="cerere && cerere.istoric && user" [istoric]="cerere.istoric" [user]="user"
                (cerereChanged)="getCerereInfo()" (isLoading)="onIsLoadingChange($event)"></app-istoric-cerere>
        </mat-card>
    </div>
    <div class="col-4">
        <mat-card>
            <div class="g-0">
                <div class="row">
                    <div class="col">
                        <div class="box-wrapper box-info">
                            <div class="box-content-header">
                                <div class="row p-1">
                                    <div class="col">
                                        <mat-card-title>
                                            <i class="fa-solid fa-circle-info"></i>
                                            <span>Info cerere</span>
                                        </mat-card-title>
                                    </div>
                                </div>
                            </div>
                            <div class="box-content-body">
                                <table class="table table-condensed table-wrapper-box">
                                    <tbody>
                                        <tr>
                                            <td width="40%" class="text-center">
                                                <strong>Subiect</strong>
                                            </td>
                                            <td class="text-left">{{ cerere?.subject }}</td>
                                        </tr>
                                        <tr>
                                            <td width="40%" class="text-center">
                                                <strong>Prioritate</strong>
                                            </td>
                                            <td class="text-left">
                                                <span class="badge" [ngStyle]="{
                                                    'background-color': cerere?.priority_bg_color,
                                                    color: cerere?.priority_color
                                                }">
                                                    {{ cerere?.priority_name }}
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="40%" class="text-center">
                                                <strong>Status</strong>
                                            </td>
                                            <td class="text-left">
                                                <span class="badge" [ngStyle]="{
                                                    'background-color': cerere?.status_bg_color,
                                                    color: cerere?.status_color
                                                }">
                                                    {{ cerere?.status_name }}
                                                </span>
                                            </td>
                                        </tr>
                                        <!-- <tr>
                                            <td width="40%" class="text-center">
                                                <strong>Cetățean</strong>
                                            </td>
                                            <td class="text-left">{{ cerere?.subject }}</td>
                                        </tr>
                                        <tr>
                                            <td width="40%" class="text-center">
                                                <strong>Cetățean email</strong>
                                            </td>
                                            <td class="text-left">{{ cerere?.subject }}</td>
                                        </tr>
                                        <tr>
                                            <td width="40%" class="text-center">
                                                <strong>Cetățean telefon</strong>
                                            </td>
                                            <td class="text-left">{{ cerere?.subject }}</td>
                                        </tr>
                                        <tr>
                                            <td width="40%" class="text-center">
                                                <strong>Cetățean cerere</strong>
                                            </td>
                                            <td class="text-left">{{ cerere?.subject }}</td>
                                        </tr> 
                                        <tr>
                                            <td width="40%" class="text-center">
                                                <strong>Creator email</strong>
                                            </td>
                                            <td class="text-left">{{ cerere?.email_sent }}</td>
                                        </tr> -->
                                        <tr>
                                            <td width="40%" class="text-center">
                                                <strong>Categorie</strong>
                                            </td>
                                            <td class="text-left">{{ cerere?.categorie_directie }}</td>
                                        </tr>
                                        <tr>
                                            <td width="40%" class="text-center">
                                                <strong>Categorie Departament</strong>
                                            </td>
                                            <td class="text-left">
                                                {{ cerere?.categorie_compartiment || "n/a" }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="40%" class="text-center">
                                                <strong>Cerere asignat</strong>
                                            </td>
                                            <td class="text-left">{{ cerere?.user_assigned }}</td>
                                        </tr>
                                        <tr>
                                            <td width="40%" class="text-center">
                                                <strong>Tip</strong>
                                            </td>
                                            <td class="text-left">{{ cerere?.type_denumire }}</td>
                                        </tr>
                                        <tr>
                                            <td width="40%" class="text-center">
                                                <strong>Sla</strong>
                                            </td>
                                            <td class="text-left">
                                                <div [innerHTML]="safeHtml"></div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="40%" class="text-center">
                                                <strong>Institutie/Directie</strong>
                                            </td>
                                            <td class="text-left">{{ cerere?.directie }}</td>
                                        </tr>
                                        <tr>
                                            <td width="40%" class="text-center">
                                                <strong>Serviciu/Birou</strong>
                                            </td>
                                            <td class="text-left">{{ cerere?.compartiment }}</td>
                                        </tr>
                                        <tr>
                                            <td width="40%" class="text-center">
                                                <strong>Dată creat</strong>
                                            </td>
                                            <td class="text-left">
                                                {{ cerere?.created_at | date : "dd-MM-yyyy HH:mm" }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="40%" class="text-center">
                                                <strong>Dată actualizat</strong>
                                            </td>
                                            <td class="text-left">
                                                {{ cerere?.updated_at | date : "dd-MM-yyyy HH:mm" }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="g-0">
                <div class="row">
                    <div class="col">
                        <div class="box-wrapper box-actiuni-cerere">
                            <div class="box-content-header">
                                <div class="row p-1">
                                    <div class="col">
                                        <mat-card-title>
                                            <i class="fa-solid fa-shuffle"></i>
                                            <span>Operațiuni cerere</span>
                                        </mat-card-title>
                                    </div>
                                </div>
                            </div>
                            <div class="box-content-body">
                                <div class="row p-2 d-flex">
                                    <!--
                                        Story: Preluare cerere
                                        Clause: OR
                                        Rules:
                                            * Sa nu fie asignat cineva pe cerere
                                            * Sa nu fiu asignat pe cerere
        
                                            ** De adaugat, permisiune pentru a putea prelua cererile...
                                    -->
                                    <div class="w-auto" *ngIf="
                                        cerere?.id_user_assigned == null ||
                                        cerere?.id_user_assigned !== user.id_user
                                    ">
                                        <button class="btn btn-light upload-btn" type="button"
                                            (click)="confirmPreluarePersonala()">
                                            <span class="upload__text">PRELUARE PERSONALĂ</span>
                                        </button>
                                    </div>

                                    <!--
                                        Story: Preluare numar din cadrul registraturii - InDoc
                                        Clause: AND
                                        Rules:
                                            * Sa fie asignat pe cerere
                                            * Sa nu aibe numar alocat pe cerere
                                            * Sa aibe dreptul la permisiunea de preluare numar din InDoc
                                    -->
                                    <div class="w-auto" *ngIf="showPreluareNumarRegistratura()">
                                        <button class="btn btn-light upload-btn" type="button"
                                            (click)="confirmPreluareNumarRegistratura()">
                                            <span class="upload__text">PRELUARE NUMĂR REGISTRATURĂ</span>
                                        </button>
                                    </div>
                                </div>
                                <div class="row p-2 d-flex">
                                    <div class="col" *ngIf="
                                        cerere?.cancel_date === null || cerere?.cancel_type === 2 
                                    ">
                                        <actiuni-cerere-card *ngIf="cerere" [cerere]="cerere" title="Status validat"
                                            description="Nevalidat" iconName="check" actionText="Validează"
                                            actionType="validate" (buttonClicked)="handleButtonClick($event)"
                                            (buttonResetClicked)="handleButtonResetClick($event)"></actiuni-cerere-card>
                                    </div>

                                    <div class="col" *ngIf="
                                        cerere?.validated_date === null &&
                                        ((cerere?.cancel_date === null && cerere?.registratura?.finalize_date === null) ||
                                        cerere?.cancel_type === 1)
                                    ">
                                        <actiuni-cerere-card *ngIf="cerere" [cerere]="cerere" title="Invalidare Cerere"
                                            description="Cerere încă valabilă de validare. Nu invalidați decât dacă este cazul!"
                                            iconName="report_problem" actionText="Invalidează" actionType="invalidate"
                                            (buttonClicked)="handleButtonClick($event)"
                                            (buttonResetClicked)="handleButtonResetClick($event)"></actiuni-cerere-card>
                                    </div>
                                    <div class="col" *ngIf="
                                        cerere?.validated_date !== null && 
                                        ((cerere?.cancel_date === null && cerere?.registratura?.finalize_date === null) ||
                                        cerere?.cancel_type === 2)
                                    ">
                                        <actiuni-cerere-card *ngIf="cerere" [cerere]="cerere" title="Clasare"
                                            description="Clasare" iconName="report_problem" actionText="Clasare"
                                            actionType="anulare" (buttonClicked)="handleButtonClick($event)"
                                            (buttonResetClicked)="handleButtonResetClick($event)"></actiuni-cerere-card>
                                    </div>

                                    <div class="col" *ngIf="
                                        cerere?.validated_date !== null ||
                                        cerere?.cancel_date !== null
                                    ">
                                        <actiuni-cerere-card *ngIf="cerere" [cerere]="cerere"
                                            title="Status Închidere Lucrare"
                                            description="Închidere lucrare doar în momentul în care a fost soluționată cererea."
                                            iconName="check" actionText="Închidere lucrare" actionType="finalizare"
                                            (buttonClicked)="handleButtonClick($event)"
                                            (buttonResetClicked)="handleButtonResetClick($event)"></actiuni-cerere-card>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <app-actualizare-cerere *ngIf="cerere" [cerere]="cerere"
                (cerereChanged)="onCerereChanged($event)"></app-actualizare-cerere>
        </mat-card>
    </div>
</div>
<div class="section-spinner position-fixed" *ngIf="isLoading">
    <div class="spinner position-absolute top-50 start-50 translate-middle">
        <img src="assets/icons/logo-ps4-icon.svg" height="50%" width="50%" alt="PS4" />
        <mat-spinner></mat-spinner>
        <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
    </div>
</div>